import { useQuery, useMutation, useQueryClient } from "react-query";
import { fetchData } from "../api/client";

export const useClientsGroups = () => {
  return useQuery(
    "clients-groups",
    async () => {
      const response = await fetchData("/clients-groups");
      return response.data || [];
    },
    {
      staleTime: 5000,
      refetchOnWindowFocus: false,
    }
  );
};

export const useUpdateClientStage = () => {
  const queryClient = useQueryClient();

  return useMutation(
    async ({ clientId, newStageId }) => {
      await fetchData(`/clients/${clientId}`, "PUT", { id_grupo: newStageId });
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries("clients");
        queryClient.invalidateQueries("awareness-pipeline-stages");
      },
    }
  );
};
